"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncSDK = void 0;
var service_1 = require("./service");
var config_1 = require("./config");
var LoggerFactory_1 = require("./factory/LoggerFactory");
var LocalStorage_1 = require("./service/LocalStorage");
var constants_1 = require("./constants/constants");
var SyncSDK = (function () {
    function SyncSDK(credentialToken, useProgramDateTime) {
        this.syncService = null;
        this.logger = LoggerFactory_1.LoggerFactory.createLogger();
        this.checkAuth = function (credToken) {
            LocalStorage_1.saveTokens(credToken);
        };
        if (credentialToken === null || !credentialToken) {
            throw new Error(constants_1.logLevel.SDK + 'Credential token is empty !');
        }
        this.checkAuth(credentialToken);
        this.syncService = new service_1.Synchronizer(!!useProgramDateTime);
    }
    SyncSDK.prototype.createGroup = function (groupId, clientName) {
        var _a;
        try {
            var socketConnection = new service_1.SocketConnection(config_1.default.WS_URl, groupId, clientName);
            (_a = this.syncService) === null || _a === void 0 ? void 0 : _a.setSocketConnection(socketConnection);
        }
        catch (error) {
            this.logger.error(constants_1.logLevel.SDK + 'Create group is failed ! ', error);
        }
    };
    SyncSDK.prototype.addPlayer = function (player, playerType) {
        var _a, _b;
        try {
            (_a = this.syncService) === null || _a === void 0 ? void 0 : _a.attachClient(player);
            (_b = this.syncService) === null || _b === void 0 ? void 0 : _b.initHls(player, playerType);
        }
        catch (error) {
            this.logger.error(constants_1.logLevel.SDK + 'Attach client', error);
        }
    };
    SyncSDK.prototype.startSynchronize = function () {
        var _a;
        (_a = this.syncService) === null || _a === void 0 ? void 0 : _a.startSyncProcess();
    };
    SyncSDK.prototype.stopSynchronize = function () {
        var _a;
        (_a = this.syncService) === null || _a === void 0 ? void 0 : _a.stopSyncProcess();
    };
    SyncSDK.prototype.attachListener = function (callback, type) {
        var _a;
        (_a = this.syncService) === null || _a === void 0 ? void 0 : _a.attachCallback(callback, type);
    };
    SyncSDK.prototype.getOffset = function () {
        var _a;
        return (_a = this.syncService) === null || _a === void 0 ? void 0 : _a.getStreamOffset();
    };
    SyncSDK.prototype.setOffset = function (offset) {
        var _a;
        (_a = this.syncService) === null || _a === void 0 ? void 0 : _a.attachStreamOffset(offset);
    };
    SyncSDK.prototype.groupPlay = function () {
        var _a;
        (_a = this.syncService) === null || _a === void 0 ? void 0 : _a.syncPlay();
    };
    SyncSDK.prototype.groupPause = function () {
        var _a;
        (_a = this.syncService) === null || _a === void 0 ? void 0 : _a.syncPause();
    };
    SyncSDK.prototype.muteGroup = function () {
        var _a;
        (_a = this.syncService) === null || _a === void 0 ? void 0 : _a.muteGroup();
    };
    SyncSDK.prototype.groupChangeVolume = function (volume) {
        var _a;
        (_a = this.syncService) === null || _a === void 0 ? void 0 : _a.changeGroupVolume(volume);
    };
    SyncSDK.prototype.sendMessageToGroup = function (message) {
        var _a;
        (_a = this.syncService) === null || _a === void 0 ? void 0 : _a.sendGroupMessage(message);
    };
    SyncSDK.prototype.sendEventToGroup = function (payload) {
        var _a;
        (_a = this.syncService) === null || _a === void 0 ? void 0 : _a.sendEventToGroup(payload);
    };
    return SyncSDK;
}());
exports.SyncSDK = SyncSDK;
//# sourceMappingURL=SyncSdk.js.map